require('./accountPaymentPurchaseDeferralView.scss');


const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
// const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const { AccountPaymentPurchaseDeferral } = require('components/accountPaymentPurchaseDeferral/accountPaymentPurchaseDeferral');

const { formatText } = require('core/i18n').i18n;

// const { GRAPHIC_TUTOR_TYPE_1 } = require('constants/index');
import { requestAccountTransactions } from 'actions/getAccountsTransactions'
const { getLavandaCards } = require('actions/lavanda');

const { LAVANDA } = require('constants/flagBasedFeatures');

const TRANSLATION_KEY_PREFIX = 'accountPaymentPurchaseDeferral';
const titleKey = TRANSLATION_KEY_PREFIX + '-headerTitle'

// const tutorial = (
//     <TutorialLauncher
//         type={GRAPHIC_TUTOR_TYPE_1}
//         title={formatText('tutorials-accountPaymentPurchaseReferralTitle')}
//         subtitle={formatText('tutorials-accountPaymentPurchaseReferralSubtitle')}
//         tooltip={formatText('tutorials-accountPaymentPurchaseReferralTooltip')}
//     />
// );

class AccountPaymentPurchaseDeferralView extends React.PureComponent {
    constructor(props){
        super(props)

        this.handleConfirmLeave = this.handleConfirmLeave.bind(this)
    }

    componentWillMount(){
        const { getLavandaCards, lavandaEnabled } = this.props;

        lavandaEnabled && getLavandaCards();
    }

    componentDidMount(){
        const { immAccount, immTransaction, requestAccountTransactions } = this.props

        !immTransaction && requestAccountTransactions(immAccount.get('accountId'))
    }

    getMappingBreadcrumb() {
        const { immAccount } = this.props
        return [{
            text: formatText('breadcrumb-accounts'),
            url: '/myprofile/accounts'
        },
        {
            text: immAccount.get('alias'),
            url: `/myprofile/accounts/${immAccount.get('accountId')}/movements`
        },
        {
            text: formatText('breadcrumb-accountsDeferredPayments'),
            url: ''
        }]
    }



    handleConfirmLeave(){
        const { history, immAccount } = this.props

        history.push(`/myprofile/accounts/${immAccount.get('accountId')}/movements`);
    }

    render() {
        const { immAccount, immAccountPaymentPurchaseDeferral, immTransaction } = this.props

        return (
            <div>
                <div className="container-fluid accounts-payment-purchase-deferral--header-identifier">
                    <div className="row">
                        <OKCover size="medium" section="accounts" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={this.getMappingBreadcrumb()}
                                finalTitle={formatText(titleKey)}
                            >
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-md-12">
                                {
                                    immTransaction &&
                                    <AccountPaymentPurchaseDeferral
                                        immAccount={immAccount}
                                        immAccountPaymentPurchaseDeferral={immAccountPaymentPurchaseDeferral}
                                        immMovement={immTransaction}
                                        onConfirmLeave={this.handleConfirmLeave}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

AccountPaymentPurchaseDeferralView.propTypes = {
    getLavandaCards: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccountPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immTransaction: PropTypes.object,
    lavandaEnabled: PropTypes.bool,
    requestAccountTransactions: PropTypes.func
};

module.exports.constructor = AccountPaymentPurchaseDeferralView;
module.exports.AccountPaymentPurchaseDeferralView = withRouter(connect(
    (state, ownProps) => ({
        immAccountPaymentPurchaseDeferral: state.accountPaymentPurchaseDeferralReducer,
        immAccount: state.accounts.getIn(['byId', ownProps.match.params.accountId]),
        immTransaction: state.accountsTransactions.getIn([ownProps.match.params.accountId, 'byId', ownProps.match.params.movementId]),
        lavandaEnabled: state.flagBasedFeatures.get(LAVANDA),
    }), {
        getLavandaCards,
        requestAccountTransactions
    })(AccountPaymentPurchaseDeferralView));
